import React, { useState, useEffect } from 'react'
import { Row, Col } from 'rsuite'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import Profile from '../../../widgets/dashboard/Profile'
import IncomeAndExpense from '../../../widgets/dashboard/accounting/IncomeAndExpense'
import IncomeAndExpenseChart from '../../../widgets/dashboard/charts/IncomeAndExpenseChart'
import InfoMainIncomAndExpense from '../../../widgets/dashboard/accounting/InfoMainIncomAndExpense'
import { getDashboard } from '../../../redux/actions/dashboard'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { sessionRemoveAll } from '../../../utils/sessionHelpers'

export default function MainIncomAndExpense() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [dashboardControl, setDashboardControl] = useState()
  const [requestBody, setRequestBody] = useState({})

  useEffect(() => {
    handelGetSchemaDashboard()

    sessionRemoveAll()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getDashboard()
      console.log('MainIncomAndExpense ', response)
      setDashboardControl(response)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </div>
    )
  }

  if (!dashboardControl || isLoading) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <PanalLoadingTemplate />
      </div>
    )
  }

  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <Row style={{ marginBottom: 30 }}>
        {dashboardControl?.profile && <Profile />}

        {/* ใช้ test */}
        <Row>
          <Col
            xs={24}
            sm={24}
            md={dashboardControl?.budgetSummary ? 14 : 24}
            lg={dashboardControl?.budgetSummary ? 14 : 24}
          >
            {dashboardControl?.projectDataTable && (
              <IncomeAndExpense setRequestBody={setRequestBody} />
            )}
            {dashboardControl?.budgetSummaryBarChart && (
              <IncomeAndExpenseChart requestBody={requestBody} />
            )}
          </Col>
          <Col xs={24} sm={24} md={10} lg={10}>
            {dashboardControl?.budgetSummary && (
              <InfoMainIncomAndExpense requestBody={requestBody} />
            )}
          </Col>
        </Row>
      </Row>
    </div>
  )
}
